import api from 'ApiConfig';

const materialService = {
  getAllmaterial: async () => {
    return api.post('/student/get-all-materials');
  },
  getvideoUrl: async () => {
    return api.post('/student/get-video-url');
  },
  getAllMaterials: async () => {
    return api.post('/student/get-all-materials');
  },
  getTrainingMaterialUrls: async () => {
    return api.post('/student/get-training-material-urls');
  },
};

export default materialService;
